import { render, staticRenderFns } from "./CheckinPromotion.vue?vue&type=template&id=8e746374&scoped=true&"
import script from "./CheckinPromotion.vue?vue&type=script&lang=js&"
export * from "./CheckinPromotion.vue?vue&type=script&lang=js&"
import style0 from "./CheckinPromotion.vue?vue&type=style&index=0&id=8e746374&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e746374",
  null
  
)

export default component.exports